import React, { Component } from "react";

var text = "";

export class ProductDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text,
    };

    this.state.text = props.text;
    this.state.category = props.category;
    this.state.description = props.description;
    this.state.price = props.price;
    this.state.currency = props.currency;
  }

  /* const [details, setDetials] = useState([]); */

  /*   componentDidMount() {
    this.setState({ text: "Bitte Produkt auswählen." });
  } */

  render() {
    return (
      <div className="productDetailsContainer">
        <div className="productDetailTitle">
          <h1>{this.state.text}</h1>
        </div>
        <div className="productDetailCatergory">
          <h3>{this.state.category}</h3>
        </div>
        <div className="productDetailDescription">
          <p>{this.state.description}</p>
        </div>
        <div className="productDetailPrice">
          <div className="productDetailPriceValue">
            <h3>{this.state.price}</h3>
          </div>
          <div className="productDetailPriceCurrency">
            <h3>{this.state.currency}</h3>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDetail;
